module.exports = __webpack_public_path__ + "img/emoji_50.fbc8916b.png";